export const SEGMIND_GOLD = {
  apiKey: process.env.REACT_APP_SEGMIND_API_KEY || 'SG_7fd5d4128029e07b',
  workflowUrl:
    process.env.REACT_APP_SEGMIND_WORKFLOW_URL ||
    'https://api.segmind.com/workflows/6a21b8844510e3c6038a3ff1-v1',
  /** Workflow image input field (from Segmind console schema) */
  workflowImageField:
    process.env.REACT_APP_SEGMIND_WORKFLOW_IMAGE_FIELD || 'image_nzkkr',
  pollIntervalMs: Number(process.env.REACT_APP_SEGMIND_POLL_INTERVAL_MS) || 8000,
  maxPollAttempts: 60,
  /** Resize longest edge before API (avoids 413 on inline base64) */
  maxImageEdge: 1024,
  jpegQuality: 0.82,
  /** Above this base64 length, upload to Firebase temp even if result uploads are off */
  maxInlineBase64Chars: 900_000,
};

/** Opt in when ready: REACT_APP_GOLD_ENABLE_FIREBASE_UPLOAD=true */
export const GOLD_ENABLE_FIREBASE_UPLOAD = true
